/*  eslint-disable no-unused-vars  */
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import { initConsoleGuard } from "./utils/consoleGuard";

// Self-XSS deterrence: warn anyone who opens the DevTools console not to paste/run
// scripts (this is medical software). Warning only — right-click and DevTools
// shortcuts stay enabled so developers can freely open the inspect panel.
initConsoleGuard({ disableContextMenu: false, deterShortcuts: false });

import aikenistLogo from "@/assets/AikenistLogo.png";
import aikenistLogoW from "@/assets/AIkenist_w.png";

const setLogo = (key, asset) => {
  const path = asset.default || asset;
  const absoluteUrl = new URL(path, document.baseURI).href;
  document.documentElement.style.setProperty(key, `url("${absoluteUrl}")`);
};

setLogo("--aikenist-logo", aikenistLogo);
setLogo("--aikenist-logo-w", aikenistLogoW);

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/en";
import ElTooltip from "element-ui/lib/tooltip";
import ElDialog from "element-ui/lib/dialog";

import VueObserveVisibility from "vue-observe-visibility";

Vue.use(VueObserveVisibility)
Vue.use(ElementUI, { locale });

const DialogComponent = ElDialog.default || ElDialog;
if (
  DialogComponent &&
  DialogComponent.props &&
  DialogComponent.props.destroyOnClose
) {
  DialogComponent.props.destroyOnClose.default = true;
}

Vue.component("el-tooltip", {
  extends: ElTooltip,
  props: {
    openDelay: {
      type: Number,
      default: 500,
    },
  },
});
Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
